function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
// @ts-strict-ignore
/** @jsx jsx */
/** @jsxFrag null */
import { jsx } from 'panel';
import { CardOnDashboard, ContentType, DashboardCard, SeenCards } from 'common/report/dashboards/types';
import { getCardIdFromContent } from 'common/report/util/dashboards/utils';
import { DashboardCardId } from 'common/report/util/saved-entities/types';
import { MIN_CARD_HEIGHT } from 'apps/boards/src/dashboards-app/card/constants';
import { CardEl, CardJsxProps } from 'apps/boards/src/dashboards-app/card';
import { SparkCardEl, SparkCardProps } from 'apps/boards/src/dashboards-app/spark-card';
export const GridCell = (_ref: {
  cards: Map<DashboardCardId, CardOnDashboard>;
  getDashboardCardComponentOptions: (card: CardOnDashboard) => CardJsxProps;
  getSparkCardComponentOptions: (cellId: string) => SparkCardProps;
  seenCards: SeenCards;
  hideNoDataFooter: boolean;
  isRHSHoverOnly: boolean;
}) => {
  let {
    cards,
    getDashboardCardComponentOptions,
    getSparkCardComponentOptions,
    seenCards,
    hideNoDataFooter = false,
    isRHSHoverOnly = false
  }: {
    cards: Map<DashboardCardId, CardOnDashboard>;
    getDashboardCardComponentOptions: (card: CardOnDashboard) => CardJsxProps;
    getSparkCardComponentOptions: (cellId: string) => SparkCardProps;
    seenCards: SeenCards;
    hideNoDataFooter: boolean;
    isRHSHoverOnly: boolean;
  } = _ref;
  return (_ref2: {
    cellId: string;
    contentId: string | number;
    contentType: ContentType;
    contentActionsHandlerOverride: CardJsxProps[`on`];
    contentParamsOverride: Partial<CardJsxProps[`params`]>;
  }) => {
    var _bookmark, _cardOptions$hook;
    let {
      cellId,
      contentId,
      contentType,
      contentActionsHandlerOverride = {},
      contentParamsOverride = {}
    }: {
      cellId: string;
      contentId: string | number;
      contentType: ContentType;
      contentActionsHandlerOverride: CardJsxProps[`on`];
      contentParamsOverride: Partial<CardJsxProps[`params`]>;
    } = _ref2;
    if (contentType === ContentType.Spark) {
      return <SparkCardEl {...getSparkCardComponentOptions(cellId)} onRemove={contentActionsHandlerOverride["remove"]} onMinHeightChanged={height => contentActionsHandlerOverride["minheightchanged"]({
        detail: {
          height
        }
      })} />;
    }
    const cardId = getCardIdFromContent(contentId, contentType);
    const card = cards.get(cardId);
    const cardOptions = card ? getDashboardCardComponentOptions(card) : null;
    if (card && (seenCards[cardId] || (_bookmark = (card as DashboardCard).bookmark) !== null && _bookmark !== void 0 && _bookmark.error)) {
      return <CardEl params={_objectSpread(_objectSpread(_objectSpread({}, cardOptions.params), contentParamsOverride), {}, {
        hideNoDataFooter,
        isRHSHoverOnly
      })} hook={cardOptions.hook} on={_objectSpread(_objectSpread({}, cardOptions.on), contentActionsHandlerOverride)} />;
    }
    return <div sel='.loading-skeleton' style={{
      'min-height': "".concat(MIN_CARD_HEIGHT[contentType], "px"),
      'border-radius': "12px"
    }}
    // use the same hook as the card to react to when the loading state is seen
    hook={(_cardOptions$hook = cardOptions === null || cardOptions === void 0 ? void 0 : cardOptions.hook) !== null && _cardOptions$hook !== void 0 ? _cardOptions$hook : {}} />;
  };
};